import { LogAnalysisState } from "./state";
export const SET_MACHINE_IMAGE_CACHE = "SET_MACHINE_IMAGE_CACHE";

export default {
    [SET_MACHINE_IMAGE_CACHE](state: LogAnalysisState, payload: [string, string]) {
        state.cachedImages.set(payload[0], payload[1]);
    },
};
